import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ImagesPage from './pages/ImagesPage';
import BookingPage from './pages/BookingPage';
import FinalizeBookingPage from './pages/FinalizeBookingPage';
import ContactPage from './pages/ContactPage';
import PricesPage from './pages/PricesPage';

import { useTranslation } from 'react-i18next';

function App() {
  const { t } = useTranslation();
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/images" element={<ImagesPage />} />
            <Route path="/prices" element={<PricesPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/booking/finalize" element={<FinalizeBookingPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Add other routes here */}
          </Routes>
        </main>
        <footer>
          <p>&copy; {new Date().getFullYear()} {t('footer.copyright')}</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
